export const videoTypes = [
    { id: 'rex', label: 'REX' },
    { id: 'best_practice', label: 'Bonne pratique' },
    { id: 'near_miss', label: 'Presque accident' },
    { id: 'lesson', label: 'Leçon ponctuelle' }
];

export const translations = {
    fr: {
        title: "Made in Chantier",
        inputTitle: "Titre",
        videoType: "Type de vidéo *",
        location: "Localisation *",
        useCurrentLocation: "Utiliser ma position actuelle",
        loadingCameras: "Chargement des caméras...",
        close: "Fermer",
        takePhoto: "Prendre une photo",
        selectImages: "Sélectionner des images",
        recordVoice: "Enregistrer une voix off (optionnel)",
        capturedPhotos: "Photos capturées",
        generateVideo: "Générer la vidéo",
        menuTitle: "Menu",
        languageSelection: "Sélection de la langue",
        links: "Liens",
        aboutMadeInChantier: "À propos de Made in Chantier",
        aboutIoga: "À propos de IOGA",
        languageSelect: "Choisir la langue"
    },
    en: {
        title: "Made in Construction",
        inputTitle: "Title",
        videoType: "Video type *",
        location: "Location *",
        useCurrentLocation: "Use my current location",
        loadingCameras: "Loading cameras...",
        close: "Close",
        takePhoto: "Take a photo",
        selectImages: "Select images",
        recordVoice: "Record voice-over (optional)",
        capturedPhotos: "Captured photos",
        generateVideo: "Generate video",
        menuTitle: "Menu",
        languageSelection: "Language Selection",
        links: "Links",
        aboutMadeInChantier: "About Made in Chantier",
        aboutIoga: "About IOGA",
        languageSelect: "Choose language"
    },
    es: {
        title: "Hecho en Construcción",
        inputTitle: "Título",
        videoType: "Tipo de video *",
        location: "Ubicación *",
        useCurrentLocation: "Usar mi ubicación actual",
        loadingCameras: "Cargando cámaras...",
        close: "Cerrar",
        takePhoto: "Tomar una foto",
        selectImages: "Seleccionar imágenes",
        recordVoice: "Grabar voz en off (opcional)",
        capturedPhotos: "Fotos capturadas",
        generateVideo: "Generar video",
        menuTitle: "Menú",
        languageSelection: "Selección de idioma",
        links: "Enlaces",
        aboutMadeInChantier: "Acerca de Made in Chantier",
        aboutIoga: "Acerca de IOGA",
        languageSelect: "Elegir idioma"
    },
    de: {
        title: "Made in Baustelle",
        inputTitle: "Titel",
        videoType: "Videotyp *",
        location: "Standort *",
        useCurrentLocation: "Meinen aktuellen Standort verwenden",
        loadingCameras: "Kameras werden geladen...",
        close: "Schließen",
        takePhoto: "Foto aufnehmen",
        selectImages: "Bilder auswählen",
        recordVoice: "Sprachaufnahme (optional)",
        capturedPhotos: "Aufgenommene Fotos",
        generateVideo: "Video generieren",
        menuTitle: "Menü",
        languageSelection: "Sprachauswahl",
        links: "Links",
        aboutMadeInChantier: "Über Made in Chantier",
        aboutIoga: "Über IOGA",
        languageSelect: "Sprache wählen"
    },
    ar: {
        title: "صنع في موقع البناء",
        inputTitle: "العنوان",
        videoType: "نوع الفيديو *",
        location: "الموقع *",
        useCurrentLocation: "استخدم موقعي الحالي",
        loadingCameras: "جاري تحميل الكاميرات...",
        close: "إغلاق",
        takePhoto: "التقاط صورة",
        selectImages: "اختيار الصور",
        recordVoice: "تسجيل صوتي (اختياري)",
        capturedPhotos: "الصور الملتقطة",
        generateVideo: "إنشاء الفيديو",
        menuTitle: "القائمة",
        languageSelection: "اختيار اللغة",
        links: "روابط",
        aboutMadeInChantier: "حول Made in Chantier",
        aboutIoga: "حول IOGA",
        languageSelect: "اختر اللغة"
    },
    pl: {
        title: "Made in Budowa",
        inputTitle: "Tytuł",
        videoType: "Typ wideo *",
        location: "Lokalizacja *",
        useCurrentLocation: "Użyj mojej obecnej lokalizacji",
        loadingCameras: "Ładowanie kamer...",
        close: "Zamknij",
        takePhoto: "Zrób zdjęcie",
        selectImages: "Wybierz zdjęcia",
        recordVoice: "Nagraj głos (opcjonalnie)",
        capturedPhotos: "Zrobione zdjęcia",
        generateVideo: "Generuj wideo",
        menuTitle: "Menu",
        languageSelection: "Wybór języka",
        links: "Linki",
        aboutMadeInChantier: "O Made in Chantier",
        aboutIoga: "O IOGA",
        languageSelect: "Wybierz język"
    },
    pt: {
        title: "Feito em Construção",
        inputTitle: "Título",
        videoType: "Tipo de vídeo *",
        location: "Localização *",
        useCurrentLocation: "Usar minha localização atual",
        loadingCameras: "Carregando câmeras...",
        close: "Fechar",
        takePhoto: "Tirar foto",
        selectImages: "Selecionar imagens",
        recordVoice: "Gravar voz (opcional)",
        capturedPhotos: "Fotos capturadas",
        generateVideo: "Gerar vídeo",
        menuTitle: "Menu",
        languageSelection: "Seleção de idioma",
        links: "Links",
        aboutMadeInChantier: "Sobre Made in Chantier",
        aboutIoga: "Sobre IOGA",
        languageSelect: "Escolher idioma"
    }
};
